module.exports = __webpack_public_path__ + "img/rock-big-04.826015e8.png";